import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { FIELD_TYPE } from 'containers/TemplatePreviewPage/constants';
import SimpleText from './SimpleText';
import TextWithMedia from './TextWithMedia';
import TextWithMediaRepeater from './TextWithMediaRepeater';
import TextArray from './TextArray';
import BooleanType from './BooleanType';
import BooleanToggleType from './BooleanToggleType';
import Scheduler from './Scheduler';
import CardType from './CardType';
import ConceptRepeater from './ConceptRepeater';
import AttributeRepeater from './AttributeRepeater';
import SimpleTextRepeater from './SimpleTextRepeater';

const TemplateVariable = ({
  question,
  questionIndex,
  questionGroupIndex,
  updateVariableValues,
  skipTopMargin,
  hasSchedulingPerk,
}) => {
  const updateVariable = useCallback(
    (value) => {
      updateVariableValues({
        questionGroupIndex,
        questionIndex,
        value,
      });
    },
    [questionIndex, questionGroupIndex, updateVariableValues],
  );

  let VariableComponent = null;

  switch (question.fieldType) {
    case FIELD_TYPE.TEXT_ARRAY:
      VariableComponent = TextArray;
      break;
    case FIELD_TYPE.TEXT:
    case FIELD_TYPE.NUMBER:
      VariableComponent = SimpleText;
      break;
    case FIELD_TYPE.TEXT_REPEATER:
      VariableComponent = SimpleTextRepeater;
      break;
    case FIELD_TYPE.TEXT_WITH_MEDIA:
      VariableComponent = TextWithMedia;
      break;
    case FIELD_TYPE.TEXT_WITH_MEDIA_REPEATER:
      VariableComponent = TextWithMediaRepeater;
      break;
    case FIELD_TYPE.BOOLEAN:
      VariableComponent = BooleanType;
      break;
    case FIELD_TYPE.BOOLEAN_TOGGLE:
      VariableComponent = BooleanToggleType;
      break;
    case FIELD_TYPE.SCHEDULER:
      VariableComponent = Scheduler;
      break;
    case FIELD_TYPE.CARD:
      VariableComponent = CardType;
      break;
    case FIELD_TYPE.CONCEPT_REPEATER:
      VariableComponent = ConceptRepeater;
      break;
    case FIELD_TYPE.ATTRIBUTE_REPEATER:
      VariableComponent = AttributeRepeater;
      break;
    default:
  }

  if (VariableComponent)
    return (
      <VariableComponent
        question={question}
        questionIndex={questionIndex}
        shouldAutoFocus={questionIndex === 0}
        autoFocus={questionIndex === 0}
        onUpdateVariable={updateVariable}
        skipTopMargin={skipTopMargin}
        id={`${questionGroupIndex}-${questionIndex}`}
        hasSchedulingPerk={hasSchedulingPerk}
      />
    );
  return null;
};

TemplateVariable.propTypes = {
  question: PropTypes.object,
  questionIndex: PropTypes.number,
  questionGroupIndex: PropTypes.number,
  updateVariableValues: PropTypes.func,
  skipTopMargin: PropTypes.bool,
  hasSchedulingPerk: PropTypes.bool,
};

export default TemplateVariable;
